import { defineNuxtPlugin } from 'nuxt/app';
import { initSdk, initByte } from '@support/utils';

export default defineNuxtPlugin(async nuxtApp => {
  let sdkInstance: any;

  const route = useRoute();
  const { source = null } = route.query;
  const { country } = route.params;
  if (process.client) {
    sdkInstance = await initSdk('PC端', {
      url_source: source,
      country
    });
    initByte('PC端', {
      url_source: source,
      country
    });
  }
  return {
    provide: {
      sensorTrack(eventName: string, params?: object) {
        sdkInstance.track(eventName, params);
        window.collectEvent(eventName, params);
      }
    }
  };
});
